import React from "react"
import classnames from "classnames"
import { MyMazdaLogin, Image } from "AtomicContainers"
import { Section, Container, H3, P, Button, Visible } from "AtomicComponents"
import styles from "./MyMazdaLoginContainer.less"
import gtmHandler from "AtomicUtils/gtmHandler"

class MyMazdaLoginContainer extends React.Component {

  _handleClickOnRegister = () => {
    const { createAccountButtonText="Create my account" } = this.props
    gtmHandler({
      pageCategory: "MyMazda - Home",
      pageAction: `CREATE AN ACCOUNT BLOCK - Clicked "${createAccountButtonText.toUpperCase()}"`
    })
  }

  render() {
    const { img, registerPageUrl, createAccountButtonText="Create my account", ...rest } = this.props
    return (
      <div className={classnames({
        [styles.ParentMyMazdaLoginContainer]: true
      })}>
        <Container styleName='screen'>
          <Section backgroundColor='#ffffff' sizeName='screen'>
            <div className={classnames({
              [styles.MyMazdaLoginContainer]: true
            })}>
              <div className={classnames({
                [styles.MyMazdaLoginContainerBox]: true,
                [styles.MyMazdaLoginContainerBoxRegister]: true
              })}>
                <div className={classnames({
                  [styles.Box1]: true
                })}>
                  <Visible visible={["screen"]}>
                    <H3>
                      Create an account
                    </H3>
                  </Visible>
                  <div>
                    <Visible visible={["screen"]}>
                      <div className={classnames({
                        [styles.BoxImage]: true
                      })}>
                        <Image
                          src={img || "/globalassets/mymazda/mazda-ownership2x.png"} />
                      </div>
                    </Visible>
                    <div className={classnames({
                      [styles.BoxPadding]: true
                    })}>
                      <P> Own a Mazda? Create your account now. </P>
                      <Button
                        fullWidth
                        onClick={this._handleClickOnRegister}
                        styleName="blackOutlined"
                        href={registerPageUrl}
                      >
                        {createAccountButtonText}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classnames({
                [styles.MyMazdaLoginContainerBox]: true
              })}>
                <MyMazdaLogin {...rest} />
              </div>
            </div>
          </Section>
        </Container>
      </div>
    )
  }
}


export default MyMazdaLoginContainer



// WEBPACK FOOTER //
// ./src/AtomicContainers/MyMazdaLoginContainer/MyMazdaLoginContainer.jsx